import React from "react";

export default () => (
  <section id="environment">
    <div className="section_left">
      <div className="section_hexagon" />
      <picture>
        <source srcSet="images/environment/img.webp" type="image/webp" />
        <img className="image" src="images/environment/img.jpg" alt="true" />
      </picture>
    </div>
    <div className="section_right">
      <div className="section_title">
        <p>ENVIRONMENT</p>
        <h2>職場環境</h2>
      </div>
      <div className="section_contents">
        <p className="title">
          私服勤務可、リモート勤務可（週2日は出社）、<br />資格取得報奨金制度、書籍購入支援制度（上限あり）<br />休憩スペース・ウォーターサーバー完備、<br />デュアルモニター設置、ノートPC支給
        </p>
        <p className="text">
          エンジニア、デザイナー、動画クリエイターなどは<br className="d-none d-lg-inline" />ハイスペックなデスクトップPCを使用しており、<br className="d-none d-lg-inline" />リモート時は全職会社支給のノートパソコン（Windows）<br className="d-none d-lg-inline" />を使用して作業します。<br />チームの親睦会やプロジェクトの打ち上げ費用も<br className="d-none d-lg-inline" />会社から支給されます。（上限あり）
        </p>
      </div>
    </div>
  </section>
)


// WEBPACK FOOTER //
// ./src/Home/Environment.js